import { faInfoCircle, faSpinnerThird } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Col, Flex, Form, Input, Row, Space, Tooltip, Typography } from 'antd'
import { useContext } from 'react'
import AvatarPicker from '../../Avatar/AvatarPicker'
import LabeledSwitch from '../../common/LabeledSwitch'
import VSpace from '../../common/VSpace'
import UsersPageContext from '../UsersPageContext'

const { Text } = Typography

const UserDetailsSection = () => {
  const {
    state: user,
    dispatch,
    isEmailAvailable,
    isEmailValid,
    isNewUser,
    isEmailValidationQueryLoading
  } = useContext(UsersPageContext)

  const isUrl = (str: string) => {
    return str.startsWith('http://') || str.startsWith('https://');
  };

  return (
    <Card title={<Space><FontAwesomeIcon icon={faInfoCircle} />User Details</Space>} bordered={false}>
      <Row gutter={24}>
        <Col span={16}>
          <VSpace>
            <LabeledSwitch
              label="This user is active"
              value={user.isActive}
              onChange={(checked) => dispatch({ type: 'SET_FIELD', fieldName: 'isActive', payload: checked })}
            />
            <Flex wrap='wrap' gap={10}>
              <Flex vertical>
                <Form.Item label='Email' style={{ marginBottom: 0 }}>
                  <Input
                    type='email'
                    placeholder="Email"
                    value={user.email}
                    onChange={(e) => dispatch({ type: 'SET_FIELD', fieldName: 'email', payload: e.target.value })}
                    status={(!isEmailAvailable || !isEmailValid) && isNewUser ? 'error' : ''}
                    disabled={!isNewUser}
                  />
                </Form.Item>
                {
                  !user.email && <Text type='danger'>Email is required</Text>
                }
                {
                  !isEmailAvailable && isNewUser && user.email && <Text type='danger'>This email is already in use</Text>
                }
                {
                  !isEmailValid && isNewUser && user.email && <Text type='danger'>Invalid email</Text>
                }
              </Flex>
              {
                isEmailValidationQueryLoading && <Flex vertical justify='center'>
                  <FontAwesomeIcon icon={faSpinnerThird} spin speed={20} />
                </Flex>
              }
              <Form.Item label='Prefix'>
                <Input
                  placeholder="Prefix"
                  value={user.prefix}
                  onChange={(e) => dispatch({ type: 'SET_FIELD', fieldName: 'prefix', payload: e.target.value })}
                  maxLength={3}
                />
              </Form.Item>
              {
                isNewUser &&
                <Tooltip title="The password must contain at least one uppercase letter, one lowercase letter, one special character, and be at least 8 characters long.">
                  <Form.Item label='Password'>
                    <Input
                      placeholder="Password"
                      value={user.password}
                      onChange={(e) => dispatch({ type: 'SET_FIELD', fieldName: 'password', payload: e.target.value })}
                    />
                  </Form.Item>
                </Tooltip>
              }
              <Form.Item label='Color'>
                <Input
                  type="color"
                  value={user.color}
                  onChange={(e) => dispatch({ type: 'SET_FIELD', fieldName: 'color', payload: e.target.value })}
                />
              </Form.Item>
              <Flex vertical>
                <Form.Item label='Display Name' style={{ marginBottom: 0 }}>
                  <Input
                    placeholder="Display Name"
                    value={user.displayName}
                    onChange={(e) => dispatch({ type: 'SET_FIELD', fieldName: 'displayName', payload: e.target.value })}
                  />
                </Form.Item>
                {
                  !user.displayName && <Text type='danger'>Display Name is required</Text>
                }
              </Flex>
            </Flex>
          </VSpace>
        </Col>
        <Col span={8} style={{ textAlign: 'start' }}>
          <AvatarPicker
            src={isUrl(user.avatar) ? `${user.avatar}?id=${Math.random()}` : user.avatar}
            alt={user.displayName}
            onModalSubmit={(newAvatar) => {
              dispatch({ type: 'SET_FIELD', fieldName: 'avatarDataBase64', payload: newAvatar })
              dispatch({ type: 'SET_FIELD', fieldName: 'avatar', payload: newAvatar })
            }}
            avatarSize={150}
          />
        </Col>
      </Row>
    </Card>
  )
}

export default UserDetailsSection
